import { createSelector } from "reselect";
import { initialState } from "./reducer";

const selectExplore = (state) => state.explore || initialState;

const selectUserFound = createSelector(selectExplore, (state) => state.users);

export { selectUserFound };